import dayjs from 'dayjs';

export const timestampToId = (isoString?: string | null): string => {
    if (!isoString) return '-';
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return '-';

    return dayjs(isoString).format('#DDMMYY/HHmmss');
};
